import { FormTextareaField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ProcessPaymentFormField } from '../../ProcessPaymentFormSchema';

export const PaymentRequestFormInternalNoteField = () => (
    <FormTextareaField name={ProcessPaymentFormField.Notes} rows={1} label={lt(TextKey.InternalNote)} />
);
